var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconGemCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12Z",
    fill: "#FFDD42"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6482_305)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.31109 8.40479H15.4328L17.4734 11.2106L12.372 17.2898L7.27051 11.2106L9.31109 8.40479Z",
    stroke: "black",
    strokeWidth: 1.02029,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.862 8.40479L10.3315 11.2106L12.3721 17.2898L14.4127 11.2106L12.8823 8.40479",
    stroke: "black",
    strokeWidth: 1.02029,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.27051 11.2107H17.4734",
    stroke: "black",
    strokeWidth: 1.02029,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6482_305"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.2435,
    height: 11.2232,
    fill: "white",
    transform: "translate(6.25 7.00195)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGemCircle);
export default __webpack_public_path__ + "static/media/icon-gem-circle.822e076c5371b7b27d4de6f4fbfca32d.svg";
export { ForwardRef as ReactComponent };